import { useEffect, useRef, useState } from 'react';
import { useOnlineStatus } from './useOnlineStatus';
import { processQueue, getQueueSize } from '../services/offlineQueue';

export function useOfflineSync() {
  const isOnline = useOnlineStatus();
  const [isSyncing, setIsSyncing] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);
  const previousOnline = useRef(isOnline);

  useEffect(() => {
    const checkPending = async () => {
      const count = await getQueueSize();
      setPendingCount(count);
    };
    checkPending();
  }, [isOnline]);

  useEffect(() => {
    // Sync when coming back online
    if (isOnline && !previousOnline.current) {
      const sync = async () => {
        const count = await getQueueSize();
        if (count > 0) {
          setIsSyncing(true);
          try {
            await processQueue();
            const remaining = await getQueueSize();
            setPendingCount(remaining);
          } finally {
            setIsSyncing(false);
          }
        }
      };
      sync();
    }
    previousOnline.current = isOnline;
  }, [isOnline]);

  return { isOnline, isSyncing, pendingCount };
}
